import { render } from "./TheFileViewer.vue?vue&type=template&id=5fce0d4c&scoped=true&ts=true"
import script from "./TheFileViewer.vue?vue&type=script&lang=ts"
export * from "./TheFileViewer.vue?vue&type=script&lang=ts"

import "./TheFileViewer.vue?vue&type=style&index=0&id=5fce0d4c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fce0d4c"]])

export default __exports__